(() => {
  'use strict';

  const MANDATORY_VARIANT_ID = 53584430334285;
  const MANDATORY_QUANTITY = 1;

  let isChecking = false;

  async function getCart() {
    const response = await fetch(
      window.Shopify.routes.root + 'cart.js',
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Could not retrieve cart');
    }

    return response.json();
  }

  async function addMandatoryProduct() {
    const response = await fetch(
      window.Shopify.routes.root + 'cart/add.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: MANDATORY_VARIANT_ID,
              quantity: MANDATORY_QUANTITY,
              properties: {
                '_mandatory_surcharge': 'true'
              }
            }
          ]
        })
      }
    );

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      console.error('Could not add mandatory surcharge:', error);
      return false;
    }

    return true;
  }

  async function enforceMandatoryProduct() {
    if (isChecking) return;

    isChecking = true;

    try {
      const cart = await getCart();

      const surchargeItems = cart.items.filter(
        item => Number(item.variant_id) === MANDATORY_VARIANT_ID
      );

      // Product isn't in cart -> add it.
      if (surchargeItems.length === 0) {
        await addMandatoryProduct();
        return;
      }

      // Make sure there is exactly ONE.
      const surcharge = surchargeItems[0];

      if (surcharge.quantity !== MANDATORY_QUANTITY) {
        await fetch(
          window.Shopify.routes.root + 'cart/change.js',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: surcharge.key,
              quantity: MANDATORY_QUANTITY
            })
          }
        );
      }

      // If duplicate surcharge lines somehow exist,
      // remove the extra ones.
      if (surchargeItems.length > 1) {
        for (let i = 1; i < surchargeItems.length; i++) {
          await fetch(
            window.Shopify.routes.root + 'cart/change.js',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                id: surchargeItems[i].key,
                quantity: 0
              })
            }
          );
        }
      }

    } catch (error) {
      console.error('Mandatory surcharge error:', error);
    } finally {
      isChecking = false;
    }
  }

  // Run when the page loads.
  document.addEventListener('DOMContentLoaded', () => {
    enforceMandatoryProduct();
  });

  // Run when returning to the page using browser navigation.
  window.addEventListener('pageshow', () => {
    enforceMandatoryProduct();
  });

  // Watch for clicks on cart controls.
  document.addEventListener('click', (event) => {
    const target = event.target.closest(
      'cart-remove-button, quantity-input button, a[href*="/cart/change"]'
    );

    if (!target) return;

    setTimeout(() => {
      enforceMandatoryProduct();
    }, 500);
  });

  // Watch for cart form submissions.
  document.addEventListener('submit', (event) => {
    const form = event.target;

    if (
      form.matches('cart-items form') ||
      form.matches('form[action*="/cart"]')
    ) {
      setTimeout(() => {
        enforceMandatoryProduct();
      }, 700);
    }
  });

  // Also periodically verify the cart.
  setInterval(() => {
    enforceMandatoryProduct();
  }, 3000);

})();